import React from 'react'
import styled from 'styled-components'

const EquipmentHeader = ({className, icon, title}) =>
(
  <Header className={className}>
    {icon && <Image className={`group`} src={icon} alt={title} />}
    <Title className={`group`}>{title}</Title>
  </Header>
)

export default EquipmentHeader

const Header = styled.div`
  margin: 0;
  padding: 0;
  display: inline-block;
  text-align: center;
  .group:before,
  .group:after {
    content: "";
    display: table;
  }
  .group:after {
    clear: both;
  }
  .group {
    zoom: 1; /* For IE 6/7 (trigger hasLayout) */
  }
`
const Image = styled.img`
  margin-right: 15px;
  max-width: 40px;
  max-height: 40px;
  display: inline-block;
  vertical-align: middle;
`
const Title = styled.span`
  font-family: Nunito;
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
  display: inline-block;
  vertical-align: middle;
  max-width: 300px;
`



// WEBPACK FOOTER //
// ./src/components/EquipmentHeader/index.js